import type { AccentHue } from "@repo/fika-design-system/color"
import type { JSX } from "solid-js"
import { Dynamic } from "solid-js/web"
import { foldedNoteClass } from "./folded-note.css"

interface FoldedNoteProps {
  hue: AccentHue
  interactive?: boolean
  href?: string
  onClick?: (e: MouseEvent) => void
  children: JSX.Element
}

export function FoldedNote(props: FoldedNoteProps) {
  function handleClick(e: MouseEvent) {
    const target = e.target as HTMLElement
    const currentTarget = e.currentTarget as HTMLElement

    if (target.closest("a") || target.closest("button")) {
      return
    }

    const roleButton = target.closest('[role="button"]')
    if (roleButton && roleButton !== currentTarget) {
      return
    }

    props.onClick?.(e)
  }

  return (
    <Dynamic
      component={props.href ? "a" : "div"}
      class={foldedNoteClass({
        hue: props.hue,
        interactive: props.interactive,
      })}
      href={props.href}
      onClick={handleClick}
      role={props.interactive ? "button" : undefined}
      tabindex={props.interactive ? "0" : undefined}
    >
      {props.children}
    </Dynamic>
  )
}
